<template>
    <b-carousel
            id="carousel-1"
            :interval="3000"
            v-model="currentSlide"
            :controls="controls"
            :indicators="indicators"
            background="#ababab"
    >
        <!-- Text slides with image -->
        <b-carousel-slide
                v-for="(slide, index) in slides"
                :key="index"
        >
            <template v-slot:img>
                <img v-if="slide.isPic"
                     :src="slide.imgSrc"
                     :width="slide.width"
                     :height="slide.height">

                <CustomVideo v-if="slide.isVideo"
                             :width="slide.width"
                             :height="slide.height"
                             :video="slide.video">
                </CustomVideo>
            </template>

            <p class="tip" v-if="slide.tip">
                <small>{{slide.tip}}</small>
            </p>
            <h3 v-if="slide.caption">{{slide.caption}}</h3>
            <p class="text" v-if="slide.text">{{slide.text}}</p>
            <b-button class="btn light" v-if="slide.btn" @click="redirect(slide.btn.to)">{{slide.btn.text}}</b-button>
        </b-carousel-slide>
    </b-carousel>
</template>

<script>
    import CustomVideo from './CustomVideo'

    export default {
        name: 'carousel',
        props: {
            slides: Array,
        },
        components: {
            CustomVideo
        },
        data() {
            return {
                currentSlide: 0,
            }
        },
        computed: {
            controls(){
                return !!(this.slides.length > 1)
            },
            indicators(){
                return !!(this.slides.length > 1)
            }
        },
        watch: {
            currentSlide(slide) {
                if (this.slides[slide].isVideo) {
                    this.slides[slide].video.autoplay = false
                }

                this.$set(this.slides, slide, Object.assign({}, this.slides[slide]))
            }
        },
        methods: {
            redirect(path) {
                this.$router.push({
                    path
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/style/var";

    .en {
        .text {
            font-size: 14px !important;
        }

        h3 {
            font-size: 28px !important;
            line-height: 38px !important;
            margin-bottom: 16px !important;
            font-family: Montserrat-SemiBold, Helvetica, Arial, sans-serif !important;
        }

        .tip {
            small {
                font-family: Montserrat-Light, Helvetica, Arial, sans-serif !important;
            }
        }
    }

    p {
        line-height: 18px;
    }

    .tip {
        margin-bottom: 15px;
        small {
            font-size: 12px;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
        }
    }

    h3 {
        margin-bottom: 18px;
        line-height: 48px;
        font-size: 30px;
        font-family: NotoSansKR-Bold, Helvetica, Arial, sans-serif;
    }

    .text {
        max-width: 450px;
        margin: 0 auto 25px auto;
        line-height: 27px;
        font-size: 16px;
    }

    .banner {
        .btn {
            //text-shadow: rgb(51, 51, 51) 1px 1px 2px;
            margin-bottom: 56px;
            font-size: 14px;
        }
    }

    .carousel {
        /deep/ .carousel-control-next, /deep/ .carousel-control-prev {
            width: 8%;
        }

        /deep/ .carousel-indicators li {
            width: 8px;
            height: 8px;
            border-radius: 100%;

            &.active {
                background-color: @primary-dark-color;
            }
        }

        /deep/ .carousel-control-prev-icon {
            width: 50px;
            height: 50px;
            background-image: url("../../assets/img/common/arrow_left.png");
        }

        /deep/ .carousel-control-next-icon {
            width: 50px;
            height: 50px;
            background-image: url("../../assets/img/common/arrow_right.png");
        }
    }

    .carousel-item {
        width: 100%;
        padding-bottom: 35.7%;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        .video-container {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
</style>
